import { Injectable } from '@angular/core';
import { NzNotificationService } from 'ng-zorro-antd/notification';
import { HttpErrorResponse } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class ErrorNotificationService {

  notiTmpl

  constructor (
    private noti: NzNotificationService
  ) {
    this.noti.config({
      nzPlacement: 'topRight',
      // nzDuration: 0,
      nzTop: 14,
    })
  }

  /** å¿éè¿ä¹çå­ä¸ä¸ª tmpl æè½ç¨ãå®å¨æ¯æ²¡æ³å°æä»ä¹æ´å¥½çåæ³ */
  init (notiTmpl) {
    this.notiTmpl = notiTmpl
  }

  notify (errRes: HttpErrorResponse) {
    if (typeof errRes.error === 'string') {
      try {
        errRes['errorObj'] = JSON.parse(errRes.error)
      } catch (e) {
        console.log(errRes.error)
      }
    } else {
      errRes['errorObj'] = errRes.error
    }
    this.noti.template(this.notiTmpl, { nzData: errRes })
  }
}
